import initialiseRouter from './router';

const page = initialiseRouter();
page.start();

function isMobileApp() {
    return (
        window.bbcAccount &&
        window.bbcAccount.locals &&
        window.bbcAccount.locals.realm
    );
}

if (isMobileApp()) {
    page.stop();
}
